<template>
  <div id="messagentWrap">

       <div class="containers">
           <div id="app"  v-cloak>
       
               <!--OVERVIEW-->
                <div class="overview" v-if="source == 'overview' ">
                    <div class="margin-bm hidden-md hidden-lg">
                       <img src="https://markup.nieuwsblad.be/extra/static/2021/podcast_pages/img/header-logo-black.png?v3" alt="" class="logo-podcasts">
                   </div>

                   <div class="margin-bl visible-md visible-lg text-center">
                       <img src="https://markup.nieuwsblad.be/extra/static/2021/podcast_pages/img/header-logo-black.png?v3" alt="" class="logo-podcasts logo-podcasts--desktop">

                        <div class="intro margin-tl margin-bl">
                            <p>Onze journalisten hebben een stem. Dat wist je al. Maar nu kan je ook werkelijk naar onze journalisten luisteren.</p>
    
                            
                        </div>

                   </div>

                   <!-- <div ref="banner" class="margin-tm margin-bl text-center hidden">
                        <img src="https://nieuwsblad.be/extra/static/2021/202112_podcast_campagne/LP_PODCASTCAMPAGNE.gif" style="width:100%;" />
                   </div> -->
           
                   <div id="overview-podcasts" class="margin-tm">
                       <h2 class="overview-titel">Onze podcasts <span class="popUpExplainerVideo">Hoe beluisteren?</span></h2>

                       
        
                       <div class="slider">
                           <swiper :options="swiperOptions"  >
                               <!-- slides -->
                               <swiper-slide v-for="(podcast, index) in podcastsSlider"  :key="index">
                                <div class="podcast-image--wrapper " > 
                                    
                                    <a :href="podcast.tagurl">
                                        <img :src="podcast.overviewimage" class="podcast-image"   />
                                        <div class="margin-tm margin-bm podcast-introshort">
                                            {{podcast.introshort}}
                                        </div>
                                    </a>
                                    <!-- <div class="podcast-label Produkt" v-if="podcast.label != '' ">
                                        {{podcast.label}}
                                    </div> -->
                                  </div>
                               </swiper-slide>
                               
                               <!-- Optional controls -->
                               <div class="swiper-pagination"  slot="pagination"></div>
                               
                           </swiper>
                            <div class="swiper-buttons-wrapper">
                                <div class="swiper-button-prev " slot="button-prev"></div>
                                <div class="swiper-button-next " slot="button-next"></div>
                            </div>

                            
                       </div>
           
                   </div>
                </div>
    
               <!--OVERVIEW-->
    
    
               <!--TAG OVERVIEW-->
    
               <div class="tag-overview" v-if="source == 'tag-overview' ">
                    <div v-for="(podcast, index) in podcastTagOverview" :key="index">
                        
                        <div class="overview-podcast--header" :style="{ backgroundColor: podcast.themecolor  }">
                            
                            <div class="overview-podcast--header-inner">

                                <nav class="breadcrumb" itemprop="breadcrumb" itemscope="" itemtype="http://schema.org/Breadcrumb" role="navigation">
                                    <ol>
                                      <li>
                                        <a href="https://www.nieuwsblad.be/podcast" itemprop="url">
                                          <b itemprop="title">Podcast</b>
                                        </a>
                                        <span class="bc__divider">&gt;</span>
                                      </li>
                                      <li>
                                        <strong><b itemprop="title">{{podcast.podcastnaam}}</b></strong>
                                      </li>
                                    </ol>
                                  </nav>

                                <div class="row ">
                                    <div class="col-md-4 ">
                                        <div class="overview-podcast--image">
                                            <img :src="podcast.overviewimage" alt="" class="img-responsive">
                                        </div>
                                    </div>
                                    <div class="col-md-8 ">
                                        <div class="margin-bm">
                                            <h2 class="helvetica podcast-title">{{podcast.podcastnaam}}</h2>
                                        </div>
                                        <span v-html="podcast.intro"></span>

                                        <div class="overview-podcast--musicshare">
                                            <h3 class="margin-bs margin-tm text-left volgpodcast-title" >Volg de Podcast:</h3>
                                            <div class="musicshare ">
                                                
                                                <a :href="podcast.spotifypodcasturl" target="_blank" v-if="podcast.spotifypodcasturl != ''" >
                                                    <img class="musicshare-item" src="https://markup.nieuwsblad.be/extra/static/2020/PODCASTS/spotify.svg?v3" alt="">
                                                </a>
                                                <a :href="podcast.applepodcasturl" target="_blank" v-if="podcast.applepodcasturl != ''" >
                                                    <img class="musicshare-item" src="https://markup.nieuwsblad.be/extra/static/2020/PODCASTS/apple_podcasts%20.svg" alt="">
                                                </a>
                                                <a :href="podcast.googlepodcasturl" target="_blank" v-if="podcast.googlepodcasturl != '' ">
                                                    <img class="musicshare-item" src="https://markup.nieuwsblad.be/extra/static/2020/PODCASTS/google_podcasts.svg" alt="">
                                                </a>
                                                <a :href="podcast.youtubepodcasturl" target="_blank" v-if="podcast.youtubepodcasturl != '' ">
                                                    <img class="musicshare-item" src="https://www.nieuwsblad.be/extra/static/2021/podcast_pages/img/youtube.svg?v1" alt="">
                                                </a>
                                                
                                              </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="overview-podcast--content">
                            <div class="overview-podcast--content-inner">

                                <h2 class="meestrecent-titel ">Meest recente afleveringen </h2>

                                <div class="margin-bl" id="backtracks-contains-multitudes"></div>

                            </div>
                        </div> -->


                        
                    </div>
               </div>
    
               <!--TAG OVERVIEW-->
               
    
    
    
    
               
    
    
    
       
           </div>
       </div>
   </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

import _ from 'lodash';



//var podcastsOverviewUrl = 'https://spreadsheets.google.com/feeds/list/13BbP4QRApjZJdtXU2NDXQ2fLcc1yFswuEoSUsS096-w/1/public/values?alt=json'
//var podcastsLatestUrl = 'https://spreadsheets.google.com/feeds/list/13BbP4QRApjZJdtXU2NDXQ2fLcc1yFswuEoSUsS096-w/2/public/values?alt=json'



export default {
  
  name: 'App',
  
  data()   { 
      return {
            podcastsOverviewAll: [],
            podcastsOverview: [],
            podcastsSlider: [],
            BTembedTemplate: "",
            BTlatestSlugs: "",

            //page settings
            platform: window.platform,
            source: window.source,
            podcastSlug: window.podcastslug,
            limit: window.limit,

            

            swiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                grabCursor: true,
                breakpoints: {
                    769: {
                        //spaceBetween: 100,
                    },
                },         
                    
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    //
                },
                
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
      }
               

           },
           mounted: function () {

               
               var self = this // create a closure to access component in the callback below

              this.fetchPodcasts();
              

               var appDiv = document.getElementById("messagentWrap")
               appDiv.classList.add(window.platform);
               appDiv.classList.add(window.source);

               if(window.source=="tag-overview") {
                setTimeout(function(){
                    self.testplayer(); 
                    //self.testjes()  
                    self.showBanner();
                }, 1000);
               }

               setTimeout(function(){
                    
                    self.showBanner();
                }, 0);

              

               

                
               

               

               
           },
           methods: {

               showBanner: function() {

                   if(this.source == 'overview') {
                       var date = new Date();
                   var startDate = new Date("December 05, 2021 21:15:00");
                   //console.log(this.$refs.banner)
                   if(date.getTime()>startDate.getTime()){
                       this.$refs.banner.classList.remove('hidden') 
                    }
                   }
                   
               },

            //    testjes : function () {
            //        console.log(this.$refs.overviewpodcasts);
            //        var sliderwrapper = this.$refs.overviewpodcasts
            //     var placesliderwrapper = document.getElementsByClassName("test")
            //     console.log(sliderwrapper)
            //     console.log(placesliderwrapper)
            //     placesliderwrapper[0].appendChild( sliderwrapper );
            //    },

               fetchPodcasts : async function () {
     
                const baseURI = 'https://interactiefcdn.nieuwsblad.be/Images/1.NEW_NB/2.SPECIALS/3.Dossiers/2021/202108_podcasts/podcasts.json?v6' + new Date().getTime()
                
                //console.log(baseURI)
                this.$http.get(baseURI)
                .then((result) => {
                    this.podcastsOverviewAll = result.data.podcasts
                   this.getActiveOverviewPodcasts();
                   this.getActiveSliderPodcasts();
                   this.getBTInfo();
                })
                },
                
               getActiveOverviewPodcasts: function() {
                   this.podcastsOverview = _.orderBy(this.podcastsOverviewAll, ['volgorde'],['asc']).filter(function (podcast) {
                   return podcast.active == "1" || podcast.active == "0"
                   }) 
               },
               getActiveSliderPodcasts: function() {
                   this.podcastsSlider = _.orderBy(this.podcastsOverviewAll, ['volgorde'],['asc']).filter(function (podcast) {
                   return podcast.active == "1"
                   }) 
               },

               getBTInfo: function() {
                    //this.BTembedTemplate = this.podcastTagOverview.filter()
                    console.log("test")
                    //var results = this.podcastTagOverview
                    for (var i = 0; i < this.podcastTagOverview.length; i++)  {
                        console.log("test")
                        this.BTembedTemplate = this.podcastTagOverview[i].configembedtemplate
                        this.BTlatestSlugs = this.podcastTagOverview[i].configlatestslugs
                        
                    }
                        
               },
           
               
               
               testplayer: function() {
                (function(p,l,a,y,s){if(p[a])return
                if(p[y])return p[y]();s=l.createElement('script')
                l.head.appendChild((s.async=p[a]=true,
                s.src='https://player.backtracks.fm/embedder.js',
                s))}(window,document,'__btL','__btR'));
                
                var episodeLimit = this.limit;
                var targetContainerElement = document.getElementById("backtracks-contains-multitudes");
                var btContext = {
                config: { 
                    showArtCover: true,
                    theme: "nieuwsblad",
                    floatingMode: "manual",
                },
                targetClassName: "bt-latest",
                embedTemplate: this.BTembedTemplate,
                latestSlugs: this.BTlatestSlugs + "?limit=" + episodeLimit
                };
                
                window.onBacktracksLoad = function(BT) {
                var xhr = new XMLHttpRequest();
                xhr.addEventListener("readystatechange", function () {
                    if (xhr.readyState === 4) {
                    var resp = JSON.parse(xhr.response);
                    if (!resp || !resp.series || !Array.isArray(resp.series.slugs)) {
                        console.log('Serie niet gevonden.');
                        return;
                    }
                    resp.series.slugs.forEach(function(targetSlug){
                        btContext.config["embed"] =  btContext.embedTemplate + targetSlug;  
                        var btPlayer = document.createElement("div");
                        targetContainerElement.appendChild(btPlayer);
                        BT.embed(btPlayer, btContext.config);
                    });
                    }
                });
                xhr.open("GET", btContext.latestSlugs, true);
                xhr.send(null);
                };
               },

               
               
            
              
           },

           computed: {
               podcastTagOverview: function() {
                   var self= this
                   return this.podcastsOverview.filter(function (podcast) {
                    return podcast.slugname == self.podcastSlug
                   })   
               }
           }
}
</script>

<style>
       
       @import url("https://www.nieuwsblad.be/extra/static/messagent/templates/2018/css/messagentWrap_bootstrap_min.css");
       @import url("https://cdn.jsdelivr.net/npm/swiper@5.3.6/css/swiper.min.css");
        @import url("https://markup.nieuwsblad.be/fonts/latest/fonts.css");
        @import url("https://markup.nieuwsblad.be/extra/static/fonts/produkt/stylesheet.css");
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css");

        /*HELPER CLASSES*/
        #messagentWrap .margin-bxs {margin-bottom:5px !important}
        #messagentWrap .margin-bs {margin-bottom:10px !important}
        #messagentWrap .margin-bm {margin-bottom:20px !important}
        #messagentWrap .margin-bl {margin-bottom:40px !important}
        #messagentWrap .margin-bxl {margin-bottom:60px !important}
        
        #messagentWrap .margin-ts {margin-top:10px !important}
        #messagentWrap .margin-tm {margin-top:20px !important}
        #messagentWrap .margin-tl {margin-top:40px !important}
        #messagentWrap .margin-txl {margin-top:60px !important}
        
        #messagentWrap .shadow {box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.22);}
        #messagentWrap .hidden {display:none}

        #app .helvetica {font-family: "Helvetica Neue Condensed" !important;}
        #app .vitesse {font-family: "Vitesse" !important; }
        #app .produkt {font-family: "Produkt" !important;}
        
        /*HELPER CLASSES*/


        /*SITE OVERRULE*/
        html { font-size: inherit; }
        .site-container {max-width:100% !important}
        .site-container__inner main {padding:0 !important}
        .site-index, .site-footer {
            background-color: #eee;
            margin: 0 auto!important;
            max-width: 62.25rem!important;
            position: relative;
        }
            /*desktop overview page */
            .widget.widget-grid {

                margin: 50px auto!important;
                padding:0;
                max-width: 62.25rem!important;
                position: relative;
            }
            .widget.widget-grid .section-title {
                margin-left:0 !important
            }
            /*desktop overview page */

        .grid {
            margin: 0 auto!important;
            max-width: 62.25rem!important;
            position: relative;
        }

        [v-cloak] {display:none}

        body {font-size:16px; background:#ffffff !important; margin:0; padding:0; font-family:Arial, Helvetica, sans-serif; overflow-x: hidden; }

       #messagentWrap {background:transparent !important; }
       #messagentWrap .breadcrumb {padding:0 !important; background-color:transparent !important}
        
       

        
        
        

        /***** OVERVIEW *****/

        .overview {padding:0px;}
        .mobile.overview {padding:5px;}
        .app.overview {padding:10px;}

        .desktop.overview #app {max-width:995px; margin:0 auto}
        

        .breadcrumb li { list-style-type: none; }

        #messagentWrap.app {background:#efefef !important;}

        #messagentWrap.app h2 {font-size:18px !important; background:white; padding:10px; margin-left:-10px; margin-right:-10px; margin-bottom:0px; font-family: "Produkt" !important; font-weight: 900; text-transform: inherit !important; font-size:27px !important; padding-bottom:20px; padding-top:30px }
        #messagentWrap.mobile h2 {font-size:16px !important; background:white; padding:8px; margin-left:-10px; margin-right:-10px; margin-bottom:0; font-family: "Produkt" !important; text-transform:uppercase; font-weight: 900; }
        #messagentWrap.desktop h2 {font-size:40px !important; background:none; padding:0px; margin-left:0px; margin-right:0px; margin-bottom:20px !important; font-family: "Produkt" !important; font-weight: 900; }
        #messagentWrap.desktop.overview h2 {font-size: 30px!important; margin-bottom: 15px !important;  padding-bottom: 15px !important;  border-bottom: 2px solid black;}

        #messagentWrap.app h3 {font-size:18px !important; background:white; padding:10px; margin-left:-10px; margin-right:-10px; margin-bottom:0; font-family: "Produkt" !important; font-weight: 900;  }
        #messagentWrap.mobile h3 {font-size:18px !important; background:white; padding:10px; margin-left:-10px; margin-right:-10px; margin-bottom:0; font-family: "Produkt" !important; font-weight: 900;  }
        #messagentWrap.desktop h3 {font-size:20px !important; background:none; padding:0px; margin-left:0px; margin-right:0px;  font-family: "Produkt" !important; font-weight: 900; text-align: left !important; }



        .overview-titel {text-transform: uppercase !important; color: #000068 !important;}
        .app .popUpExplainerVideo, .mobile .popUpExplainerVideo {display:none !important}
        .desktop .popUpExplainerVideo {font-weight: 700; padding: 10px; color: #000068;
        font-family: Helvetica Neue Condensed,Arial,Helvetica,sans-serif;
        font-size: 15px;
        text-decoration: none;
        height: 40px;
        background-color: #ffffff;
        text-transform: uppercase; float:right}
        .popUpExplainerVideo:hover {
            text-decoration: underline;
            cursor: pointer;
        }
       
        #messagentWrap  .logo-podcasts {max-width: 90%; image-rendering: -webkit-optimize-contrast;}
        #messagentWrap  .logo-podcasts--desktop {max-width: 600px; image-rendering: -webkit-optimize-contrast;}

        #messagentWrap .intro {font-size:18px !important; max-width:60%; margin:0 auto}
        #messagentWrap .intro h4 {font-size:1.8rem;}

        /*SLIDERS*/
            #messagentWrap .slider { margin-left:-10px; margin-right:-10px}
            #messagentWrap.desktop .slider { margin-left:0px; margin-right:0px}
            #messagentWrap.desktop .swiper-slide img:hover {cursor:grab}
            .swiper-container {                    
                width: 100%; touch-action: pan-y !important;
            }
            
            #messagentWrap .swiper-slide {
                width: 65%;
                max-width:320px;
                height:auto;
            }

            #messagentWrap.desktop .swiper-slide {
                width: 65% !important;
                max-width:280px;
                height:auto;
            }

            #messagentWrap .swiper-wrapper {height:auto !important; display: flex;}

            #messagentWrap.desktop .swiper-pagination {position:relative; margin-top:30px}
            #messagentWrap.app .swiper-pagination, #messagentWrap.mobile .swiper-pagination {display:none}
            #messagentWrap.app .swiper-button-prev, #messagentWrap.mobile .swiper-button-prev {display:none}
            #messagentWrap.app .swiper-button-next, #messagentWrap.mobile .swiper-button-next {display:none}

            .swiper-button-next, .swiper-button-prev {position:relative !important}
            .swiper-button-next {float:right !important; left:-9px !important}
            .swiper-button-prev {float:left !important; left:7px !important}

            .swiper-button-next:after, .swiper-button-prev:after {  font-family: inherit !important; font-size:0 !important; }
            .swiper-button-next:after {content: url("https://www.nieuwsblad.be/extra/static/2021/podcast_pages/img/arrow-next.svg?v2") !important}
            .swiper-button-prev:after {content: url("https://www.nieuwsblad.be/extra/static/2021/podcast_pages/img/arrow-prev.svg?v2") !important}

            .swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled { opacity: 0 !important; }
            .swiper-buttons-wrapper {top:-20px; position:relative}
            
            #app .swiper-pagination-bullet-active {background:#000068 !important}


            .podcast-image {max-width:100%}
            .podcast-label {position:absolute; background: yellow; padding: 5px 10px;}
            .mobile .podcast-introshort, .app .podcast-introshort {display:none}
            a .podcast-introshort, a:hover .podcast-introshort {color:black !important; text-decoration:none !important;}
            #messagentWrap a:hover, #messagentWrap a:focus {text-decoration: none;}

        /*SLIDERS*/


       /***** OVERVIEW *****/


        /***** TAG OVERVIEW *****/

        .tag-overview {padding: 0;}

        iframe {background:white;}
        #backtracks-contains-multitudes  {background:url("https://markup.nieuwsblad.be/extra/static/2020/2020_gidsen/img/preloader.gif") no-repeat center top; min-height:100px; margin-bottom:10px}

        #messagentWrap.app .meestrecent-titel {text-transform: normal !important; font-size:29px !important;}
        #messagentWrap.mobile .meestrecent-titel {text-transform: inherit !important; font-size:27px !important}
        #messagentWrap.desktop .meestrecent-titel {text-transform: normal !important; font-size:29px !important; margin-bottom:40px !important; color: #000068;}
        
       .overview-podcast--header  {background:#efefef; padding:20px 15px; margin-bottom:40px}
       .overview-podcast--header-inner {max-width: 995px; margin:0 auto}
       .overview-podcast--content  {background:#ffffff; padding:20px 15px;}
       .overview-podcast--content-inner {max-width: 995px; margin:0 auto}
       .overview-podcast--header .row {display: flex; justify-content: center;  align-items: center; }

       .overview-podcast--musicshare .musicshare-item {max-width:200px; width:100%; margin:2px 2px}
       .volgpodcast-title {text-align: center !important; background:none !important; text-transform:uppercase; }

       @media screen and (max-width: 768px) {

           .podcast-title {display:none !important;}
           

           .container {margin:0; padding:0;}
           .breadcrumb {display:none !important}
        
        #messagentWrap.tag-overview {padding-top:0}
        .overview-podcast--header  {padding-top:0}
        .overview-podcast--header .row {display: block;}
        .overview-podcast--image {margin-left:-15px; margin-right:-15px}
        
        .overview-podcast--musicshare {text-align: center;}
        .overview-podcast--musicshare .musicshare-item {max-width:160px;}

        }

        

        /***** TAG OVERVIEW *****/


        /*REBRANDING */
[data-testid="show-more"] {
    background: #000068 !important;
}

.section-title.section-title--tag {color:#000068 !important}
.section-title {
    margin-left: 0;
    font-family: "produkt" !important;
}

.desktop .faq-title {}
       
       
      
   </style>
